import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Modal, Button } from 'Components';
import './ApiErrorModal.css';

const ApiErrorModal = props => (
  <Modal show={props.show}>
    <div className="api-error-modal">
      <div className="api-error-modal__container">
        {<h3>{props.errorMessage === props.Message ? '' : props.errorMessage ? props.errorMessage : i18n.t('common:PageUnavailable')}</h3>}
        {props.Message && <h3>{props.Message}</h3>}
        {(!(props.hidePageUnavailableDescription || props.Message)) && <h4>{i18n.t('common:PageUnavailableDescription')}</h4>}
        <div className="api-error-modal__buttons">
          {props.isCloseable ?
            <Button
              onClick={props.onCloseClick ? props.onCloseClick : () =>
                props.setAppState({
                  isAPIErrorModalOpen: false,
                  apiErrorMessage: '',
                  isApiErrorModalCloseable: false,
                })
              }
              className="button button--primary"
            >
              {i18n.t('common:Close')}
            </Button> :
            <Button
              onClick={() =>
                props.setAppState({
                  isAPIErrorModalOpen: false,
                  apiErrorMessage: '',
                  shouldRedirectToBV: false,
                }, props.shouldRedirectToBV ? window.open('https://bvna.com/', '_self') : () => window.location.reload())
              }
              className="button button--primary"
            >
              {props.shouldRedirectToBV ? i18n.t('common:Close') : i18n.t('common:refresh')}
            </Button>
          }
        </div>
      </div>
    </div>
  </Modal>
);

ApiErrorModal.propTypes = {
  Message: PropTypes.string,
  errorMessage: PropTypes.string,
  setAppState: PropTypes.func,
  show: PropTypes.bool,
  isCloseable: PropTypes.bool,
  onCloseClick: PropTypes.func,
  hidePageUnavailableDescription: PropTypes.bool,
  shouldRedirectToBV: PropTypes.bool,
};

export default ApiErrorModal;



// WEBPACK FOOTER //
// ./src/components/ApiErrorModal/ApiErrorModal.jsx